import { municipiosApi, oficinasApi } from "../../../api/catalogosApi";

// IP_DEPOT_STOCK_CATALOGO_V1
// SOLO LECTURA - NO CAMBIAR IDS OPERATIVOS

export const STOCK_OFICINAS_OFICIALES = {
  BACALAR: ["OFI_bdd0486b-42f2-47bf-84e2-2678cb6bc343", "MUN_911e717f-c799-4e04-9ec7-ec3ee6fcbfed"],
  BJ_TRANSITO: ["OFI_09398fc5-0c42-46fd-b047-74daf50731e2", "MUN_951a6d52-bf6f-404d-9910-452cb57fb348"],
  BJ_TAXISTAS: ["OFI_e2308e1c-60bb-442d-bf6b-f56c9e463338", "MUN_951a6d52-bf6f-404d-9910-452cb57fb348"],
  FELIPE_CARRILLO_PUERTO: ["OFI_72e47156-0c56-462b-8f88-87df51b1d81f", "MUN_819f4f61-530a-4ec7-8a35-60ffb5279901"],
  COZUMEL: ["OFI_62afa856-d49e-450f-ab6a-89764e0cf9cf", "MUN_6eb1c496-3240-4df2-9801-52ce8a222d38"],
  ISLA_MUJERES_INSULAR: ["OFI_ef651a1e-c24f-47dc-86b5-5c57f6dce373", "MUN_c1fc502f-066e-4ea0-8f1f-1914e78958b6"],
  ISLA_MUJERES_CONTINENTAL: ["OFI_aaabb753-df67-4c1c-bb66-34e438752e04", "MUN_c1fc502f-066e-4ea0-8f1f-1914e78958b6"],
  JOSE_MARIA_MORELOS: ["OFI_a39b3e0c-8701-4a21-bc26-0112e57b9328", "MUN_367aa3d4-df7b-4631-93fc-d9af4cf57b3b"],
  LAZARO_CARDENAS: ["OFI_30036bd2-63ba-4667-83de-796bcdf1f2e4", "MUN_c71ddcc1-df81-45ab-93dc-3280f826919c"],
  OTHON_P_BLANCO: ["OFI_36edc355-b92d-4b0a-a2cd-79c1a2dda513", "MUN_19815d96-4c9c-4c0b-a13e-8ab51d3343b5"],
  PUERTO_MORELOS: ["OFI_3177d361-6d07-4ddf-8c87-c4152e1ecf76", "MUN_e5ab5c03-e9da-404e-8eb4-c7337411ae3f"],
  PLAYA_TRANSITO: ["OFI_d61b652c-9510-47a7-b2d2-dd0aca8319db", "MUN_283f7856-3b3a-4e04-a0d2-e103cfbaa9f0"],
  PLAYA_PALMERAS: ["OFI_2861b765-5a7a-4c99-b025-45f2db05279e", "MUN_283f7856-3b3a-4e04-a0d2-e103cfbaa9f0"],
  TULUM: ["OFI_8cbf7784-72a6-476a-a558-0ce27135aaf8", "MUN_bc86fb26-0041-4cb6-b424-39e5be1c4bf2"],
  UNIDAD_MOVIL_1: ["OFI_06934dc2-e29b-4468-b376-bf74bd83edaf", "MUN_80267647-8c3c-4467-a0a4-106ffb1c9698"],
  UNIDAD_MOVIL_2: ["OFI_3819af29-f9dd-478d-9e6f-727b902598f9", "MUN_80267647-8c3c-4467-a0a4-106ffb1c9698"],
};

export async function cargarNombresOficialesStock() {
  const [oficinas, municipios] = await Promise.all([
    oficinasApi.listar({ includeInactive: false }),
    municipiosApi.listar({ includeInactive: false })
  ]);

  if (!Array.isArray(oficinas) || !Array.isArray(municipios)) {
    throw new Error("Respuesta inesperada de catalogos");
  }

  const oficinasMap = new Map(oficinas.map(item => [item.id, item]));
  const municipiosMap = new Map(municipios.map(item => [item.id, item]));

  const resultado = {};

  Object.entries(STOCK_OFICINAS_OFICIALES).forEach(
    ([idOperativo, [oficinaId, municipioId]]) => {
      const oficina = oficinasMap.get(oficinaId);
      const municipio = municipiosMap.get(municipioId);

      if (
        !oficina ||
        !municipio ||
        oficina.activo === false ||
        municipio.activo === false ||
        oficina.municipioId !== municipioId ||
        !oficina.nombre ||
        !municipio.nombre
      ) {
        console.warn("[STOCK_CATALOGO] Sin equivalencia valida", idOperativo);
        return;
      }

      resultado[idOperativo] = {
        nombre: oficina.nombre,
        municipio: municipio.nombre
      };
    }
  );

  return resultado;
}